(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('countries', countriesService);

    function countriesService(sfHttp, config) {

        this.get = function (search) {

            const request = {
                params: {}
            };

            if (search) {
                request.ignoreLoadingBar = true;
                request.params.search = search === '' ? undefined : '*' + search + '*';
            }

            return sfHttp.get(config.apiUrl + 'countries', request);
        };
    }
})();
